import React from 'react';
import styles from './watchlistTickerAutocompleteStyles';

import Autocomplete from 'buyside/components/presentation/Autocomplete/autocomplete';

class WatchlistTickerAutocomplete extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, suggestions: [], followLoading: false };
    this.handleAutocomplete = this.handleAutocomplete.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
    this.selectIntercept = this.selectIntercept.bind(this);
  }

  handleAutocomplete(results) {
    const formatSuggestion = obj => {
      if (obj.ticker) {
        return {
          label: `${obj.ticker} - ${obj.entity_name}`,
          id: obj.id
        };
      } else {
        return { label: obj.entity_name, id: obj.id };
      }
    };

    const suggestions = [
      results.exact_matches.length > 0 && {
        title: this.props.CUSIP ? 'CUSIP Match' : 'Exact Ticker Match',
        data: results.exact_matches,
        suggestions: results.exact_matches.map(result => formatSuggestion(result))
      },
      results.matching_tickers.length > 0 && {
        title: 'Partially Matching Tickers',
        data: results.matching_tickers,
        suggestions: results.matching_tickers.map(result => formatSuggestion(result))
      },
      results.matching_names.length > 0 && {
        title: 'Matching Companies by Name',
        data: results.matching_names,
        suggestions: results.matching_names.map(result => formatSuggestion(result))
      }
    ].filter(section => section);
    this.setState({ loading: false, suggestions });
  }

  selectIntercept(_, selectedItem) {
    const { followEntity } = this.props;
    if (this.state.followLoading) return;
    this.setState({ followLoading: true });
    followEntity({
      variables: { id: selectedItem.id, skipSideEffects: true }
    }).then(({ data: { followObject } }) => {
      this.setState({ followLoading: false });
      if (followObject && followObject.message) {
        this.setState({ error: followObject.message, success: null });
      } else {
        this.setState({ error: null, success: `Sucessfully Added Ticker ${selectedItem.label}` });
      }
    });
  }

  changeIntercept(searchTerm, reason) {
    const { refetch } = this.props;
    if (this.state.error) this.setState({ error: null });
    if (this.state.success) this.setState({ success: null });
    if (reason === 'input-changed') {
      this.setState({ loading: true });
      refetch({
        query: searchTerm,
        assetClass: 'Equity',
        includeLocalAsset: true,
        skip: false
      }).then(res => {
        const results = JSON.parse(res.data.securitySearch);
        this.handleAutocomplete(results, searchTerm);
      });
    }
  }

  render() {
    const { suggestions, loading, error, followLoading, success } = this.state;

    return (
      <div>
        <Autocomplete
          selectIntercept={this.selectIntercept}
          changeIntercept={this.changeIntercept}
          suggestions={suggestions}
          loading={loading}
          debounce
          inputProps={{
            id: 'watchlistTickerAutocomplete',
            className: styles.autocomplete,
            disabled: followLoading
          }}
          autosuggestOptions={{
            focusInputOnSuggestionClick: false,
            multiSection: true
          }}
        />
        {error && <div className={styles.errorText}>{error}</div>}
        {success && <div className={styles.successText}>{success}</div>}
      </div>
    );
  }
}

export default WatchlistTickerAutocomplete;
